import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Download } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Side panel of the GDPR tab. Asking for consent and recording it moved into
 * the status card, where they follow the status [HW-1055].
 */
export function CandidateGdprQuickActions() {
  return (
    <TooltipProvider delayDuration={200}>
      <section className="space-y-2 rounded-lg border border-border bg-background p-4">
        <h3 className="text-sm font-medium">Quick actions</h3>
        <div className="space-y-1.5">
          <DisabledReasonWrap reason="Export job ships in Phase 3">
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="w-full justify-start"
              disabled
            >
              <Download className="mr-2 h-4 w-4" />
              Download candidate data
            </Button>
          </DisabledReasonWrap>
        </div>
      </section>
    </TooltipProvider>
  );
}

/**
 * Wraps a (usually disabled) control in a Tooltip that explains why it's
 * unavailable. Disabled buttons don't fire pointer events on their own, so
 * the child is wrapped in a span that catches hover/focus for the tooltip
 * to attach. When `reason` is null, the child is rendered unwrapped.
 */
export function DisabledReasonWrap({
  reason,
  children,
}: {
  reason: string | null;
  children: ReactNode;
}) {
  if (!reason) return <>{children}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="block w-full">{children}</span>
      </TooltipTrigger>
      <TooltipContent side="top">{reason}</TooltipContent>
    </Tooltip>
  );
}
